import axios from 'axios';
import { handleSessionExpired } from '../auth/sessionExpired';

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const useToken = error.config?.useToken !== false;

    if (status === 401 && useToken) {
      handleSessionExpired(error.config?.url || '');
    }

    return Promise.reject(error);
  }
);

export default class BaseService {
  static async get({ url, useToken = true}) {
    return await this.execute({ url, method: 'GET', useToken });
  }

  static async post({ url, data, useToken = true}) {
    return await this.execute({ url, method: 'POST', data, useToken });
  }

  static async put({ url, data, useToken = true}) {
    return await this.execute({ url, method: 'PUT', data, useToken });
  }

  static async delete({ url, useToken = true}) {
    return await this.execute({ url, method: 'DELETE', useToken });
  }

  static async patch({ url, data, useToken = true}) {
    return await this.execute({ url, method: 'PATCH', data, useToken });
  }

  static async postMultipart({ url, data, useToken = true }) {
    return await this.execute({
      url,
      method: 'POST',
      data,
      useToken,
      options: { headers: {} },
    });
  }

  static async execute({ url, method, data = {}, useToken = true, options = {} }) {
    const defaultOptions = {
      // eslint-disable-next-line no-undef
      url: `${process.env.REACT_APP_BASE_URL}/${url}`,
      method,
      data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      useToken,
      ...options
    }
    if (useToken) {
      const { stateRoot } = await import('../store');
      defaultOptions.headers = {
        ...defaultOptions.headers,
        'Authorization': `Bearer ${stateRoot().auth.token}`,
      }
    }
    return await axiosInstance(defaultOptions);
  }

}
